import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ShellNavigationComponent } from './navigation.component';
import { RouterModule } from '@angular/router';
import { TooltipModule} from 'primeng/tooltip';
import {MenubarModule } from 'primeng/menubar';
import {MatSidenavContainer, MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatExpansionModule} from '@angular/material/expansion';

import { SelectButtonModule } from 'primeng/selectbutton';

import { ToggleSwitchModule} from 'primeng/toggleswitch';

import { CommonCheckService, CommonDataModule, GuiService, NovitaetenLookupService, SwitchThemeService } from 'FoxxyLib';

import { MessageService } from 'primeng/api';
import { StoreModule } from '@ngrx/store';
import { navigationfeatureName, reduceNavigation } from './store';
import { FluidModule } from 'primeng/fluid';
import { OverlayBadge } from 'primeng/overlaybadge';
import { BadgeModule } from 'primeng/badge';
import { SortRouteReuseStrategy } from '@sortapp/app/classess/sort-reuse-strategy';
import { AppCommonModule } from '@sortapp/app/app-module';






@NgModule({
    providers:[SwitchThemeService, MatSidenavContainer, CommonCheckService,  MessageService, SortRouteReuseStrategy  ],
    imports: [
        CommonModule,
        AppCommonModule,
        FluidModule,
        FormsModule,
        RouterModule,
        SelectButtonModule,
        ToggleSwitchModule,
        TooltipModule,
        MatExpansionModule,
        MenubarModule,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatIconModule,
        MatBadgeModule,
        MatListModule,
        OverlayBadge,
        BadgeModule,
     //   StoreModule.forFeature(navigationfeatureName, reduceNavigation),

    ],
    exports: [ ShellNavigationComponent  ],
    declarations: [
        ShellNavigationComponent
    ]
})
export class ShellSortimentierenModule { }
